function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs13030"
}, /*#__PURE__*/React.createElement("clipPath", {
  id: "eh-a"
}, /*#__PURE__*/React.createElement("path", {
  id: "path13027",
  fillOpacity: 0.7,
  d: "M-158.7 0H524v512h-682.7z"
})));

var SvgEh = function SvgEh(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "flag-icons-eh",
    viewBox: "0 0 640 480",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "g13044",
    fillRule: "evenodd",
    clipPath: "url(#eh-a)",
    transform: "translate(148.8) scale(.94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect13190",
    fill: "#000",
    d: "M-158.3 0h680.9v255.3h-680.9z",
    style: {
      strokeWidth: 1.38978
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect13192",
    fill: "#007a3d",
    d: "M-158.3 255.3h680.9v255.3h-680.9z",
    style: {
      strokeWidth: 1.38978
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect13194",
    fill: "#fff",
    d: "M-158.3 148.9h680.9v212.8h-680.9z",
    style: {
      strokeWidth: 1.55382
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13196",
    fill: "#c4111b",
    d: "m-158.3 0 340.4 255.3-340.4 255.3Z",
    style: {
      strokeWidth: 1.70213
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle13198",
    cx: 352.3,
    cy: 255.3,
    r: 68.1,
    fill: "#c4111b",
    style: {
      strokeWidth: 1.70213
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle13200",
    cx: 377.9,
    cy: 255.3,
    r: 68.1,
    fill: "#fff",
    style: {
      strokeWidth: 1.70213
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13202",
    fill: "#c4111b",
    d: "m334 296.5 29.1-20.7 28.8 21-10.8-34 29-20.9-35.7-.2-11-34-11.2 33.9-35.7-.2 28.7 21.2-11.1 34z",
    style: {
      strokeWidth: 1.70213
    }
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEh, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eh.edba217f.svg";
export { ForwardRef as ReactComponent };